// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3XlOx","title":"Info_title__2JodZ","links":"Info_links__3q86p","link":"Info_link__gyYcy","logo":"Info_logo__3kwpQ"};